import Crud from '../views/Tipo_Conselho/Crud'
import Entity from '../views/Tipo_Conselho/Add'

let routes = {
    path: '/tipo_conselhos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_conselhos/add',
            name: 'NewTipoConselho',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Tipo Conselho',
                breadcrumb: [
                    {
                        text: 'Tipos de Conselho',
                        to: '/tipo_conselhos',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_conselhos/edit/:id?',
            name: 'EditTipoConselho',
            component: Entity,
            meta: {
                pageTitle: 'Editar Tipo Conselho',
                breadcrumb: [
                    {
                        text: 'Tipos de Conselho',
                        to: '/tipo_conselhos',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_conselhos',
            name: 'list-tipo_conselhos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Conselho',
                breadcrumb: [
                    {
                        text: 'Tipos de Conselho',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
